import React, { useState } from "react"
import "./fileUpload.css"
import UploadIcon from "../../assets/Images/icons/uploadIcon.svg"
const FileUpload = ({ title = "", showIcon = true, acceptValue, preview, onSelect = () => { }, maxSize = 5 }) => {
  const [imagePreview, setImagePreview] = useState(preview || null)

  const changeHandler = (e) => {
    const file = e.target.files[0];
    if (file.size > maxSize * 1024 * 1024) {
      alert(`File size should not exceed ${maxSize} MB`);
      return;
    }
    setImagePreview(URL.createObjectURL(file))
    onSelect({
      preview: URL.createObjectURL(file),
      file: file,
    })
  }

  const RemoveImageHandler = () => {
    setImagePreview(null)
    onSelect(null)
  }

  return (

    imagePreview ? <div className="relative">
      <div className="border-1 rounded-[14px] relative overflow-hidden">
        <img src={imagePreview}
          class="w-[280px] h-[120px] object-fill"
        // className="w-[280px] h-[160px] object-fill"
        />
      </div>

      <button
        type="button"
        className="absolute top-2 right-2 w-[24px] h-[24px] bg-[#f5f5f5] text-[#42495280] rounded-full flex items-center justify-center shadow-md hover:bg-[#e0e0e0]"
        onClick={RemoveImageHandler} // Add your handler function
      >
        &times;
      </button>
    </div>
      :
      <div className="cursor-pointer flex flex-grow"  >
        <label for={title} className="border border-dashed border-[#42495280] py-[22px]  cursor-pointer rounded-[16px] justify-center flex flex-col items-center flex-grow">
          {showIcon ? (
            <img
              src={UploadIcon}
              alt="upload icon"
              className="w-[24px] aspect-square mb-[28px]"
            />
          ) : null}
          <p className="font-[400] text-[12px] leading-[24px] text-[#42495280]">
            {title}
          </p>
        </label>
        <input id={title} type="file" className="file-upload-input" accept={acceptValue} onChange={changeHandler} />
      </div>


  )
}

export default FileUpload
